import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useT } from '@transifex/react';
import { Button } from '@raisin/components-lib';
import { formatLocaleForIntl, isCOM, isCSR, PREFERRED_LOCALE_COOKIE_NAME, REDIRECT_ORIGIN_COOKIE_NAME, REDIRECT_TARGET_COOKIE_NAME, removeUrlParamByKey, UNIFIED_DOMAIN_LOCALES, } from '@raisin/cp-utils';
import { CountryPicker } from '../../../components';
import { useMarkets } from '../../../hooks/useMarkets';
import messages from './messages';
import * as S from './styles';
const CountryPickerBanner = () => {
    const [visible, setVisible] = useState(false);
    const { locale } = useIntl();
    const t = useT();
    const router = useRouter();
    const pickerConfig = useMarkets();
    let activeMarketLocale = locale;
    let currentCountry = (pickerConfig === null || pickerConfig === void 0 ? void 0 : pickerConfig[locale]) || false;
    if (isCOM()) {
        const currentCountryLocale = window.location.pathname.split('/')[1];
        const pickerConfigLocale = formatLocaleForIntl(currentCountryLocale);
        if (UNIFIED_DOMAIN_LOCALES.includes(currentCountryLocale)) {
            currentCountry = pickerConfig[pickerConfigLocale];
            activeMarketLocale = pickerConfigLocale;
        }
    }
    useEffect(() => {
        var _a;
        const isClient = isCSR();
        const getQueryParam = (key) => { var _a; return isClient ? new URLSearchParams(window.location.search).get(key) : (_a = router === null || router === void 0 ? void 0 : router.query) === null || _a === void 0 ? void 0 : _a[key]; };
        const redirectTarget = getQueryParam(REDIRECT_TARGET_COOKIE_NAME);
        const redirectOrigin = getQueryParam(REDIRECT_ORIGIN_COOKIE_NAME);
        if (isClient) {
            let shouldShowBanner = false;
            if (redirectOrigin) {
                Cookies.set(PREFERRED_LOCALE_COOKIE_NAME, redirectOrigin);
                window.history.pushState('', '', removeUrlParamByKey(REDIRECT_ORIGIN_COOKIE_NAME));
            }
            if (redirectTarget) {
                Cookies.set(REDIRECT_TARGET_COOKIE_NAME, redirectTarget);
                window.history.pushState('', '', removeUrlParamByKey(REDIRECT_TARGET_COOKIE_NAME));
                shouldShowBanner = true;
            }
            setVisible(shouldShowBanner);
        }
        if (currentCountry && !((_a = router === null || router === void 0 ? void 0 : router.query) === null || _a === void 0 ? void 0 : _a[REDIRECT_ORIGIN_COOKIE_NAME])) {
            const preferredLocale = Cookies.get(PREFERRED_LOCALE_COOKIE_NAME);
            const hasRedirectCookie = Cookies.get(REDIRECT_TARGET_COOKIE_NAME);
            const isLocaleMismatch = isCOM() && preferredLocale !== currentCountry.preferredLocale;
            if (isLocaleMismatch || hasRedirectCookie) {
                setVisible(true);
            }
        }
    }, [currentCountry, currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.preferredLocale, router === null || router === void 0 ? void 0 : router.query]);
    const handleClose = () => {
        setVisible(false);
        if (isCSR()) {
            Cookies.set(PREFERRED_LOCALE_COOKIE_NAME, currentCountry.preferredLocale);
            Cookies.set(REDIRECT_TARGET_COOKIE_NAME, '', { expires: -1 });
        }
    };
    const handleSelect = (event) => {
        event.preventDefault();
        if (isCSR()) {
            Cookies.set(PREFERRED_LOCALE_COOKIE_NAME, event.target.dataset.preferredLocale);
            Cookies.set(REDIRECT_TARGET_COOKIE_NAME, '', { expires: -1 });
            window.location.href = event.target.href;
        }
    };
    return (React.createElement(React.Fragment, null, visible ? (React.createElement(S.CountryPickerWrapper, null,
        React.createElement(S.FlexContainer, null,
            React.createElement(S.BannerCopy, null,
                t(messages.selectCountryParagraph1),
                React.createElement(S.LineBreak, null),
                " ",
                t(messages.selectCountryParagraph2)),
            React.createElement(CountryPicker, { markets: pickerConfig, direction: "down", align: "left", locale: activeMarketLocale, onSelect: handleSelect, inHeader: true }),
            React.createElement(Button, { size: "small", onClick: handleClose }, t(messages.allGood))))) : null));
};
export default CountryPickerBanner;
//# sourceMappingURL=index.js.map